import moment from 'moment';

/**
 * A renewed/extended loan released before the branch's current system date can no longer be deleted;
 * one released on (or before) the system date still can (inclusive boundary).
 */
export function isRenewalReleaseDateDeletable(isRenewedLoan, releaseDate, branchSystemDate) {
  if (!isRenewedLoan || !releaseDate || !branchSystemDate) {
    return true;
  }
  return !branchSystemDate.isAfter(moment(releaseDate), 'day');
}
